import type { LoaderFunctionArgs } from '@remix-run/node'
import { Navigate, useLoaderData } from '@remix-run/react'
import { cartLoader } from '~/loaders/cart'

export const loader = async (context: LoaderFunctionArgs) =>
  cartLoader({ ...context, currentStage: 'myaccount' })

export default function MyAccountIndexRoute() {
  useLoaderData<typeof loader>()

  return <Navigate to="/myaccount/dados-cadastrais" />
}
